<template>
  <div class='SuccessPwRecovery'>
    Senha atualizada com sucesso,&nbsp;<span @click="$router.push('/loja')">retornar a loja</span>
  </div>
</template>

<script>
export default {
  name: 'SuccessPwRecovery'
}
</script>

<style scoped>
.SuccessPwRecovery {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

span {
  color: #3c6bc9;
  cursor: pointer;
}
</style>
